import styled from 'styled-components';
import Heading from '../../../atoms/Heading/Heading';

export const FooterHeading = styled(Heading)`
  text-transform: uppercase;
`;
